module.exports = __webpack_public_path__ + "static/media/stocks.fb430a5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tradingPreferences/stocks.svg
// module id = 162
// module chunks = 21